import { MONTHS_IN_SPANISH } from '../../config/settings/constants'

/* Get the months names in spanish */
export const getMonthNames = month => {
  return MONTHS_IN_SPANISH[month]
}

/**
 * Generates a message with the given date.
 */
export const getDateMessage = (dateParam = new Date()) => {
  const day = dateParam.getDate()
  const month = getMonthNames(dateParam.getMonth())
  const year = dateParam.getFullYear()

  return `los ${day} días del mes de ${month} de ${year}`
}

/**
 * Format a given date in yyyy-MM-dd to a message.
 */
export const formatDateMessage = dateString => {
  const [year, month, day] = dateString.split('-')
  const monthName = getMonthNames(parseInt(month, 10) - 1)
  return `${parseInt(day, 10)} de ${monthName} de ${year}`
}
